/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ScanByIdFacilityResponse } from './scan-by-id-facility-response';
import { ScanByIdStatusResponse } from './scan-by-id-status-response';
import { ScanByIdContainerResponse } from './scan-by-id-container-response';


export interface ScanByIdResponse { 
    id: string;
    facility: ScanByIdFacilityResponse;
    containers: Array<ScanByIdContainerResponse>;
    containersCount: number;
    foundDevicesCount: number;
    devicesWithoutModelCount: number;
    scannedCount: number;
    totalCount: number;
    isApprovable: boolean;
    status: ScanByIdStatusResponse;
    createdDate: string;
}

